export default __webpack_public_path__ + "static/italy-07514b144358d91ffbd905fbcdc100c0.png";